import {ComponentProps} from "react";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useLeadFormModalClose} from "../../hooks/use_lead_form_modal_close";
import {LeadFormWithNegotiation} from "../lead_form/LeadFormWithNegotiation";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Omit<ComponentProps<typeof LeadFormWithNegotiation>, "customHeader">;

export const LeadFormModalWithNegotiation = (props: IProps) => {
    const {handleModalClose} = props;
    const {formCloseSnapshotRef, handleModalCloseWithTracking} = useLeadFormModalClose(handleModalClose);

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalCloseWithTracking}
            title="Negocjuj cenę"
            containerClassName={containerStyles}
            testId={OFFER_TEST_IDS.LEAD_FORM.NEGOTIATION_FORM}
        >
            <LeadFormWithNegotiation
                {...props}
                formCloseSnapshotRef={formCloseSnapshotRef}
                handleModalClose={handleModalCloseWithTracking}
                customHeader={null}
            />
        </LeadFormModalWrapper>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "544px",
        h: "auto",
        overflow: "visible"
    }
});
import {ComponentProps} from "react";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useLeadFormModalClose} from "../../hooks/use_lead_form_modal_close";
import {LeadFormWithNegotiation} from "../lead_form/LeadFormWithNegotiation";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Omit<ComponentProps<typeof LeadFormWithNegotiation>, "customHeader">;

export const LeadFormModalWithNegotiation = (props: IProps) => {
    const {handleModalClose} = props;
    const {formCloseSnapshotRef, handleModalCloseWithTracking} = useLeadFormModalClose(handleModalClose);

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalCloseWithTracking}
            title="Negocjuj cenę"
            containerClassName={containerStyles}
            testId={OFFER_TEST_IDS.LEAD_FORM.NEGOTIATION_FORM}
        >
            <LeadFormWithNegotiation
                {...props}
                formCloseSnapshotRef={formCloseSnapshotRef}
                handleModalClose={handleModalCloseWithTracking}
                customHeader={null}
            />
        </LeadFormModalWrapper>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "544px",
        h: "auto",
        overflow: "visible"
    }
});
